module.exports = __webpack_public_path__ + "media/levelup2.e35acdbb.webm";